export default "__VITE_ASSET__SvhoAvOC__"